import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, RowSelectEventArgs, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs, TextWrapSettingsModel  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { delay, map, Observable, retry } from 'rxjs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';


@Component({
  selector: 'app-myob-service-invoice-comparitor',
  templateUrl: './myob-service-invoice-comparitor.component.html',
  styleUrls: ['./myob-service-invoice-comparitor.component.scss']
})
export class MyobServiceInvoiceComparitorComponent implements OnInit {

  @Input() sent_data?: any; // not used

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('comparitor_grid')
  public comparitor_grid: GridComponent;
  
  
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public selIndex: number[] = [];
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };

  // public wrapSettings: { wrapMode: 'Content' | 'Both' | 'Header' }; // this allows the content to wrap only Header|Content|Both
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both

      // TABS sets the selected
      @ViewChild('staticTabs') staticTabs: TabsetComponent;
      
      // today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
      // today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
      // action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
      // action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison


  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  set_RowVersion: any;
  IsIndividual: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  difference_results: any[];
  comparitor_array: any[];
  baseMyobCustomers: any;
  search_results: any;
  selectedrecords: object[];
  Items2: any;
  comparitor_array_B: any;
  comparitor_array_A: any;
  myobInvoices: Object;
  invoices: any;
  comparitor_array_B_FULL: any; //?[]
  comparitor_array_A_FULL: any;

  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
  ) { 
   
    // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  }

  ngOnInit() {

    // Loading the data using the buttons to later introduce the search facility for the invoice grid.

   // this.getInvoices();
    
    // Load the data
   // this.getMyobInvoices();



        // Grid Options
        this.toolbarOptions = ['ExcelExport', 'Search'];
        this.initialPage = { pageSize:5 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['UID'] }; // sets auto grouping for the grid
        this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };
        // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };

        this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both

            //checkbox selection options
        // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
        this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 

        // end date filter options
        // End Grid Options

        // DID NOT WORK AS I HVE NOT GOT MATCHING ARRAYS
        // Gets the difference between the two arrays
        // this.difference_results = this.difference(this.job_table_clients, this.sent_data)

  }




  // uses demo services but calls to myob
  public getMyobInvoices() {
    return  this._demoService.getMyobInvoices()
    .pipe(
      this.toastr.observe({
        loading: 'Connecting)',
        success: '🚀',
        error: '😡'
     })
     )
    .pipe(
      retry(5), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
    .subscribe(
        data => { this.myobInvoices = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
  
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  



              this.toastr.info('Myob Datas Gathered')
              // console.log(this.Items);
              // this.Address = this.Items['Address'];
            // return this.myobCustomers;

            // this.comparitor_array = [];
            // this.baseMyobCustomers.items = DataUtil.parse.parseJson(data); 
            // this.baseMyobCustomers = DataUtil.parse.parseJson(data); 
            this.baseMyobCustomers =  this.Items;
            // console.log(JSON.stringify(this.baseMyobCustomers))
            //  console.log(JSON.stringify(this.Items))

            if (!this.comparitor_array){this.comparitor_array = [];}
            if (!this.comparitor_array_B){this.comparitor_array_B = [];}
            if (!this.comparitor_array_B_FULL){this.comparitor_array_B_FULL = [];}

            // Count items and then push to the comparitor array with same being sent from the myob call.
            // let  count_of_items = Object.keys(this.baseMyobCustomers).length;
            let  count_of_items = this.baseMyobCustomers.length;
            console.log("Count of items: " + count_of_items);

            // // now loop and push to join model
            for(let i=0;i < count_of_items; i++) {
              let res_push = this.baseMyobCustomers[i];

            // console.log("Tax code: " + res_push.SellingDetails.FreightTaxCode.UID)

                // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                this.comparitor_array.push({
                 
                  invoice_id: res_push.invoice_id,
                //  invoice_number: res_push.invoice_number,
                  Number: res_push.Number,
                  UID: res_push.UID,
                  RowVersion: res_push.RowVersion,
                  Status: res_push.Status,
                  invoice_total: res_push.TotalAmount,
                  invoice_gst: res_push.TotalTax,
                  invoice_subtotal:res_push.Subtotal,
                  invoice_payment_total: res_push.payment,
                  invoice_remaining_total: res_push.BalanceDueAmount,
                  CustomerName: res_push.Customer.Name,
                  CustomerDisplayID: res_push.Customer.DisplayID,
                  TermsDueDate: res_push.TermsPaymentIsDue,
                //  TaxCode: res_push.TaxCode.UID,
                  FreightTaxCode: res_push.FreightTaxCode.UID,
                  LastModified: res_push.LastModified,
                  items: res_push.Lines,
                  via:'MYOB',

                        });

                this.comparitor_array_B.push({
                  invoice_id: res_push.invoice_id,
                //  invoice_number: res_push.invoice_number,
                  Number: res_push.Number,
                  UID: res_push.UID,
                  RowVersion: res_push.RowVersion,
                  Status: res_push.Status,
                  invoice_total: res_push.TotalAmount,
                  invoice_gst: res_push.TotalTax,
                  invoice_subtotal:res_push.Subtotal,
                  invoice_payment_total: res_push.payment,
                  invoice_remaining_total: res_push.BalanceDueAmount,
                  CustomerName: res_push.Customer.Name,
                  CustomerDisplayID: res_push.Customer.DisplayID,
                  TermsDueDate: res_push.TermsPaymentIsDue,
               //   TaxCode: res_push.TaxCode.UID,
                  FreightTaxCode: res_push.FreightTaxCode.UID,
                  LastModified: res_push.LastModified,
                  items: res_push.Lines,
                  via:'MYOB',
                        });  
                        
                        this.comparitor_array_B_FULL.push({
                      //     invoice_id: res_push.invoice_id,
                      //   //  invoice_number: res_push.invoice_number,
                      //     Number: res_push.Number,
                      //     UID: res_push.UID,
                      //     RowVersion: res_push.RowVersion,
                      //     Status: res_push.Status,
                      //     invoice_total: res_push.TotalAmount,
                      //     invoice_gst: res_push.TotalTax,
                      //     invoice_subtotal:res_push.Subtotal,
                      //     invoice_payment_total: res_push.payment,
                      //     invoice_remaining_total: res_push.BalanceDueAmount,
                      //     CustomerName: res_push.Customer.Name,
                      //     CustomerDisplayID: res_push.Customer.DisplayID,
                      //     TermsDueDate: res_push.TermsPaymentIsDue,
                      //  //   TaxCode: res_push.TaxCode.UID,
                      //     FreightTaxCode: res_push.FreightTaxCode.UID,
                      //     LastModified: res_push.LastModified,
                      //     items: res_push.Lines,
                          ...res_push,
                          via:'MYOB',
                                });         


            } // end brands loop.
            this.comparitor_array =  this.comparitor_array;
            this.comparitor_grid.refresh(); // refreshes this grid
            this.toastr.success("Myob Invoices pushed to comparitor array");












        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }



    getInvoices() {
      this._demoService.getInvoices().subscribe(
         data => { this.invoices = data; 
        
        
        
            // comparitor update
            // this.Items = data['job_table_clients'];
            this.Items = data;


            // console.log(this.Items);
            // this.Address = this.Items['Address'];
            // return this.myobCustomers;

            // this.comparitor_array = [];
            // this.baseMyobCustomers.items = DataUtil.parse.parseJson(data); 
            // this.baseMyobCustomers = DataUtil.parse.parseJson(data); 
            this.baseMyobCustomers =  this.Items; // set above as items....
            // console.log(JSON.stringify(this.baseMyobCustomers))
            //  console.log(JSON.stringify(this.Items))

            if (!this.comparitor_array){this.comparitor_array = [];} 
            if (!this.comparitor_array_A){this.comparitor_array_A = [];} 
            if (!this.comparitor_array_A_FULL){this.comparitor_array_A_FULL = [];} 

            // Count items and then push to the comparitor array with same being sent from the myob call.
            // let  count_of_items = Object.keys(this.baseMyobCustomers).length;
            let  count_of_items = this.baseMyobCustomers.length;
            console.log("Count of items: " + count_of_items);

            // // now loop and push to join model
            for(let i=0;i < count_of_items; i++) {
            let res_push = this.baseMyobCustomers[i];

            // console.log("Tax code: " + res_push.SellingDetails.FreightTaxCode.UID)

            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.comparitor_array.push({


              invoice_id: res_push.invoice_id,
              //  invoice_number: res_push.invoice_number,
                Number: res_push.invoice_number,
                UID: res_push.UID,
                RowVersion: res_push.RowVersion,
                Status: res_push.invoice_status_name,
                invoice_total: res_push.invoice_total,
                invoice_gst: res_push.invoice_gst,
                invoice_subtotal:res_push.invoice_subtotal,
                invoice_payment_total: res_push.invoice_payment_total,
                invoice_remaining_total: res_push.invoice_remaining_total,
                CustomerName: '',
                CustomerDisplayID: 'TSA' + res_push.toe_brand_id,
                TermsDueDate: res_push.due_date,
              //  TaxCode: res_push.TaxCode.UID,
                FreightTaxCode: res_push.FreightTaxCode,
                LastModified: res_push.LastModified,
                items: res_push.Lines,
                via:'TSA',
                    });
                    
            this.comparitor_array_A.push({
              invoice_id: res_push.invoice_id,
              //  invoice_number: res_push.invoice_number,
                Number: res_push.invoice_number,
                UID: res_push.UID,
                RowVersion: res_push.RowVersion,
                Status: res_push.invoice_status_name,
                invoice_total: res_push.invoice_total,
                invoice_gst: res_push.invoice_gst,
                invoice_subtotal:res_push.invoice_subtotal,
                invoice_payment_total: res_push.invoice_payment_total,
                invoice_remaining_total: res_push.invoice_remaining_total,
                CustomerName: '',
                CustomerDisplayID: 'TSA' + res_push.toe_brand_id,
                TermsDueDate: res_push.due_date,
              //  TaxCode: res_push.TaxCode.UID,
                FreightTaxCode: res_push.FreightTaxCode,
                LastModified: res_push.LastModified,
                items: res_push.Lines,
                via:'TSA',
                    }); 
                    
                    this.comparitor_array_A_FULL.push({
                      invoice_id: res_push.invoice_id,
                      // //  invoice_number: res_push.invoice_number,
                      //   Number: res_push.invoice_number,
                      //   UID: res_push.UID,
                      //   RowVersion: res_push.RowVersion,
                      //   Status: res_push.invoice_status_name,
                      //   invoice_total: res_push.invoice_total,
                      //   invoice_gst: res_push.invoice_gst,
                      //   invoice_subtotal:res_push.invoice_subtotal,
                      //   invoice_payment_total: res_push.invoice_payment_total,
                      //   invoice_remaining_total: res_push.invoice_remaining_total,
                      //   CustomerName: '',
                      //   CustomerDisplayID: 'TSA' + res_push.toe_brand_id,
                      //   TermsDueDate: res_push.due_date,
                      // //  TaxCode: res_push.TaxCode.UID,
                      //   FreightTaxCode: res_push.FreightTaxCode,
                      //   LastModified: res_push.LastModified,
                      //   items: res_push.Lines,
                      ...res_push,
                        via:'TSA',
                            }); 





            } // end brands loop.
            this.comparitor_array =  this.comparitor_array;
            //this.comparitor_grid.refresh();
            this.toastr.success("TSA Invoices pushed to comparitor array");
        
        
        
        
        
        
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }

// :: Grid Functions



refreshGrid(){ // refresh the databutton
  // this.loadList(this.doc_id);
  this.comparitor_array = []; // just empties the array. that way stop it keep adding and
  this.getInvoices();
  this.getMyobInvoices();
//  this.comparitor_grid.refresh();
};

clearComparison(){
  this.comparitor_array = []; // just empties the array.
}




// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.comparitor_grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.comparitor_grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.comparitor_grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.comparitor_grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.comparitor_grid.excelExport();
  }
}
// rowDataBound(args: RowDataBoundEventArgs) {
//   const job_status = 'job_status';
//   if (args.data[job_status] === 'CLOSED') {
//       args.row.className = 'strikethrough';
//   }
// }


rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'payment_status';
    if (args.data[job_status] === 'OVERDUE') {
        args.row.className = 'text-danger';
    }
    const status = 'status'
    if (args.data[status] === 'completed' || args.data[status] === 'on-hold' || args.data[status] === 'cancelled'  ) {
      args.row.className = 'text-muted';
      // disable the check box for complete / onhold / refunded orders.
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox'); 
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox') 
      }

      // Disable if not even have a myob ID
      const RowVersion = 'RowVersion'
      if (args.data['UID'] == '' ) {
        args.row.className = 'text-muted';
        // disable the check box for complete / onhold / refunded orders.
        args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox'); 
        args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox') 
        }
}

public dataBound(args): void {
  if (this.selIndex.length) {
      this.comparitor_grid.selectRows(this.selIndex);
      this.selIndex = [];
  }
}

      /// TABS
      selectTab(tab_id: number) {
        this.staticTabs.tabs[tab_id].active = true;
      };










      rowSelected(args: RowSelectEventArgs) {

        // console.log('selected data object: ' + JSON.stringify(args.data));
              //  // simply push the object/s seleceted to the  this.search_results array.
              //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
              //  this.search_results.push({
              //    ...args.data
              //  });
              // if (typeof args.data === 'object' && args.data !== null && args.data[0].id >= 0 ){
              //   console.log('We have a header object of data selected');
              // }
      
              //checks if single object
              if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
                if(!this.search_results){this.search_results = [];}; // detect if array exists.
                console.log('We have a single object of data selected');
                  this.search_results.push({
                  ...args.data
                  });
              this.toastr.info( this.search_results.length + ' Clicked added to search results'); 
      
              }
      
              // if an a list of objects need to count and then loop through.
              if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                console.log('We have a OBJECT of object of data selected');
                const count_selected = this.comparitor_grid.getSelectedRecords().length;
                console.log('count: ' + count_selected); // lenth is used for myob comparitor array
                const length = Object.keys(args.data).length
                console.log('length: ' + length);
              
                // now loop and insert individually
                if(!this.search_results){this.search_results = [];}; // detect if array exists.
                for(let i=0;i < length; i++) {
                  this.search_results.push({
                  ...args.data[i]
                  });
                  }
                 this.toastr.info( this.search_results.length + ' Clicked added to search results');
                }
      
      
      
        const selectedrowindex: number[] = this.comparitor_grid.getSelectedRowIndexes();  // Get the selected row indexes.
        // alert(selectedrowindex); // To alert the selected row indexes.
        const selectedrecords: object[] = this.comparitor_grid.getSelectedRecords();  // Get the selected records.
        this.selectedrecords = this.comparitor_grid.getSelectedRecords();
      
      
        }
      
      
      
      
              // we also need to create a row deselect event to remove from args
              rowDeSelected(args: RowSelectEventArgs) {
      
                
                const selectedrowindex: number[] = this.comparitor_grid.getSelectedRowIndexes();  // Get the selected row indexes.
                // alert(selectedrowindex); // To alert the selected row indexes.
                const selectedrecords: object[] = this.comparitor_grid.getSelectedRecords();  // Get the selected records.
                this.selectedrecords = this.comparitor_grid.getSelectedRecords();
      
                // console.log('selected data object: ' + JSON.stringify(args.data));
                      //  // simply push the object/s seleceted to the  this.search_results array.
                    //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
                    //  // clear the the search results. forst then re-add.
                    //  this.search_results = [];
                    //    this.search_results.push({
                    //      ...args.data
                    //    });
       
                    let argData = args.data;
                if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
                  console.log('We have a single object of data de-selected');
                  let base_search_results = this.search_results
                  
                  // this.search_results = []; 
                  // this.search_results.push({
                  //   ...args.data
                  //   });
                  
       
      
                    // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                    this.search_results =  this.search_results.filter(function (order) {
                      // return true for salary greater than equals to 25000
                      console.log('leaving IDs= ' + args.data['id'] + ' != ' + order.id);
                      return order.id != args.data['id'];
                    });
                    this.toastr.warning( ' Order Remved from the action list'); 
       
      
                // remove
                // filter and remove the selected ones from the object first.
                    // let remove_unselected = this.comparitor_grid.getSelectedRowIndexes();
                    // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
                  
                }    
      
      
                // if an a list of objects need to count and then loop through.
                if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                  console.log('We have a OBJECT of object of data DE-selected');
                  const count_selected = this.comparitor_grid.getSelectedRecords().length;
                  console.log('count: ' + count_selected); // both count methods work.
                  // const length = Object.keys(args.data).length
                  // console.log('length: ' + length);
                
                  // now loop and insert individually
             //     this.search_results = []; 
                  for(let i=0;i < count_selected; i++) {
                    // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
                  //   this.search_results.push({
                  //  ...args.data[i]
                  //   });
      
                    // leave items where not selected 
                        // this.search_results =  this.search_results.filter(function (order) {
                        // // return true for salary greater than equals to 25000
                        // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                        // return order.id != args.data['id'];
                        // });
                        // this.search_results = this.search_results;
      
                                     // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                    this.search_results =  this.search_results.filter(function (order) {
                      // return true for salary greater than equals to 25000
                      console.log('leaving IDs= ' + args.data[i]['id'] + ' != ' + order.id);
                      return order.id != args.data[i]['id'];
                    });
                   
      
                    }
      
                    this.toastr.warning( ' Orders Remved from the action list'); 
                
                  }
      
      
              
                }




          clearSearchResults(){
            this.search_results = [];
            // this.comparitor_array_A = [];
            this.comparitor_array_A_FULL = [];
            // this.comparitor_array_B = [];
            this.comparitor_array_B_FULL = [];
            this.toastr.info('Clearing All Comparitor FULL arrays complete.')
          }





  // :: Grid Functions









}
